import { ICollaborationSummary as IAaNgCollaborationSummary } from 'aa-ng';

import { IUnit } from '.';
import { ActivityType } from './enums';

export interface ICollaborationSummary {
  collaboratorPersonId: number;
  collaboratorPersonGuid: string;
  activityType: ActivityType;
  numberOfCollaborations: number;
  collaboratorPrimaryUnit?: IUnit;
  activityYears?: (number | null)[];
  activityIds?: number[];
}

export function mapCollaborationSummary(
  collaborationSummary: ICollaborationSummary,
): IAaNgCollaborationSummary {
  const { collaboratorPrimaryUnit } = collaborationSummary;

  return {
    ...collaborationSummary,
    activityTypeId: collaborationSummary.activityType,
    collaboratorPrimaryUnitId: collaboratorPrimaryUnit?.id,
    collaboratorPrimaryUnitName: collaboratorPrimaryUnit?.name,
  } as IAaNgCollaborationSummary;
}
